import { Injector, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { NbCardModule, NbSpinnerModule } from '@nebular/theme';
import { TableParcelasComponent } from './table-parcelas.component';
import { ModalTableParcelasComponent } from './modal-table-parcelas.component';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
	imports: [
		CommonModule,
		Ng2SmartTableModule,
		NbCardModule,
		NbSpinnerModule,
		PipesModule
	],
	declarations: [
		TableParcelasComponent,
		ModalTableParcelasComponent
	],
	exports: [
		TableParcelasComponent,
		ModalTableParcelasComponent
	],
})

export class TableParcelasModule { }


// WEBPACK FOOTER //
// ./src/app/components/table-parcelas/table-parcelas.module.ts